import {
  AitCellData,
  AitColumnRepeat,
  AitRowData,
  AitRowGroupData,
  AitTableData,
} from "./interface";
import { AsupInternalTable } from "./AsupInternalTable";

export type { AitCellData, AitColumnRepeat, AitRowData, AitRowGroupData, AitTableData };
export { AsupInternalTable };
